import { API_BASE } from '../../constants';
import { SheetFundPolicesUseCase } from '../../usecases';
import { makeHttpGet } from '../';

export const makeSheetFundPolicies = () => {
  const url = `${API_BASE}/funds/policies`;
  const httpGet = makeHttpGet();

  return new SheetFundPolicesUseCase(url, httpGet);
};
